<template>
    <div class="profile_edit_content_block">
        <Breadcrumbs :type="type" :header="title" :url="url" :head="head"></Breadcrumbs>
        <trashed-message v-if="post.deleted_at" class="mb-6" @restore="restore"> This post has been deleted.
        </trashed-message>
        <div class="w-full bg-white rounded-md shadow overflow-hidden edit_form_block">
            <form @submit.prevent="update">
                <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 mt-3 p-4">
                    <template v-if="host_selected == false">
                        <select-input-function v-model="form.host_id" :error="form.errors.host_id" class="sm:col-span-2"
                            label="Host" required="true" :action="loadResident">
                            <option :value=null>Select Host</option>
                            <option v-for="host in hosts" :key="host.id" :value='host.id'>{{ host.full_name }}</option>
                        </select-input-function>
                    </template>
                    <select-input v-model="form.resident_id" :error="form.errors.resident_id" class="sm:col-span-2"
                        label="Resident" required="true">
                        <option :value=null>Select Resident</option>
                        <option v-for="resident in residentList" :key="resident.id" :value='resident.id'>{{
                            resident.title }}</option>
                    </select-input>
                    <text-input v-model="form.post_title" :error="form.errors.post_title" class="sm:col-span-2"
                        label="Title" required="true" placeholder="i.e. Anitya Cave House" @keyup="slugBuild" />
                    <text-input v-model="form.slug" :error="form.errors.slug" class="sm:col-span-2" label="Slug"
                        required="true" placeholder="i.e anitya-cave-house" />
                    <textarea-input v-model="form.post_desc" :error="form.errors.post_desc" class="sm:col-span-2"
                        label="Post Description" required="true"
                        placeholder="i.e In the heart of Cappadocia, Ortahisar, a cavehouse of 80 square meter, fully equipped kitchen with a scenic terrace is offered for a relaxing and enjoyable vacation." />
                    <text-input v-model="form.cancelation_time" :error="form.errors.cancelation_time"
                        class="sm:col-span-2" :label="'Cancellation Time (Minute)-' + cantime" placeholder="i.e. 5"
                        :type="'number'" oninput="this.value = Math.abs(this.value)" min="0" />
                    <text-input v-model="form.free_cancelation" :error="form.errors.free_cancelation"
                        class="sm:col-span-2" label=" Fee of Cancellation (Percentage)" placeholder="i.e. 5"
                        :type="'number'" oninput="this.value = Math.abs(this.value)" min="0" />
                    <text-input v-model="form.maximum_guest" :error="form.errors.maximum_guest" class="sm:col-span-2"
                        label="Maximum Guest" placeholder="i.e. 4" :type="'number'"
                        oninput="this.value = Math.abs(this.value)" min="0" />
                    <text-input v-model="form.maximum_infants" :error="form.errors.maximum_infants"
                        class="sm:col-span-2" label="Maximum Infants" placeholder="i.e. 4" :type="'number'"
                        oninput="this.value = Math.abs(this.value)" min="0" />
                    <text-input v-model="form.maximum_children" :error="form.errors.maximum_children"
                        class="sm:col-span-2" label="Maximum Children" placeholder="i.e. 4" :type="'number'"
                        oninput="this.value = Math.abs(this.value)" min="0" />
                    <text-input v-model="form.maximum_pet" :error="form.errors.maximum_pet" class="sm:col-span-2"
                        label="Maximum Pet" placeholder="i.e. 4" :type="'number'"
                        oninput="this.value = Math.abs(this.value)" min="0" />
                    <text-input v-model="form.max_boking_day" :error="form.errors.max_boking_day" class="sm:col-span-2"
                        label="Max Booking Day" placeholder="i.e. 4" oninput="this.value = Math.abs(this.value)" min="0"
                        :type="'number'" />
                    <text-input v-model="form.min_boking_day" :error="form.errors.min_boking_day" class="sm:col-span-2"
                        label="Min Booking Day" placeholder="i.e. 1" oninput="this.value = Math.abs(this.value)" min="0"
                        :type="'number'" />
                    <status-toogle-button v-model="form.restricted" :error="form.errors.restricted" label="Restricted"
                        class="sm:col-span-2 flex items-center mt-4"></status-toogle-button>
                    <template v-if="form.restricted == true">
                        <text-input :type="'date'" v-model="form.start_date" :error="form.errors.start_date"
                            class="sm:col-span-2" label="Start Date" placeholder="i.e. 1" />
                        <text-input :type="'date'" v-model="form.end_date" :error="form.errors.end_date"
                            class="sm:col-span-2" label="End Date" placeholder="i.e. 1" />
                    </template>
                    <TextareaInput v-model="form.note" :error="form.errors.note" class="sm:col-span-2" label="Note"
                        placeholder="i.e. More details, refund policy and many more" />
                    <text-input v-model="form.email" :error="form.errors.email" class="sm:col-span-2" label="Email"
                        :type="email" required="true" placeholder="i.e example@test.com" />
                    <text-input v-model="form.mobile" :error="form.errors.mobile" class="sm:col-span-2" label="Mobile"
                        placeholder="i.e +63-2-1234-5678" />
                    <status-toogle-button v-model="form.status" :error="form.errors.status" label="Post Status"
                        class="sm:col-span-2 flex items-center mt-4"></status-toogle-button>
                    <div class="sm:col-span-3 grid grid-cols-2 gap-y-2 gap-x-1 mb-1">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-400">Amenity</label>
                        <Button :name="'Add'" :icon="'far fa-plus-circle'" :method="open_aminety_popup"></Button>
                        <div class="col-span-2 grid grid-cols-2 gap-y-2 gap-x-1 mb-1 border-t border-gray-300 p-3">
                            <ul class="flex  flex-wrap gap-2 col-span-2">
                                <li class="flex items-center w-auto c-list px-2 py-1"
                                    v-for="(amenity, n_index) in form.amenities" v-if="form.amenities.length > 0">
                                    {{ aminety_title(amenity) }}
                                </li>
                                <li v-else class="w-full py-2 italic">
                                    <span class="far fa-circle-info"></span>
                                    No Amenity Selected
                                </li>
                            </ul>
                        </div>
                        <div class="col-span-2">
                            <amenity :amenities="form.amenities" :amenityopen="amenityopen"
                                @UpdateAminetyPopup="update_aminety_popup" @UpdateAminety="update_aminety">
                            </amenity>
                        </div>
                    </div>

                    <div class="sm:col-span-3 grid grid-cols-2 gap-y-2 gap-x-1 mb-1">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-400">Category <span
                                class="custom-error">*</span></label>
                        <Button :name="'Add'" :icon="'far fa-plus-circle'" :method="open_category_popup"></Button>
                        <div class="col-span-2 grid grid-cols-2 gap-y-2 gap-x-1 mb-1 border-t border-gray-300 p-3">
                            <ul class="flex  flex-wrap gap-2 col-span-2">
                                <li class="flex items-center w-auto c-list px-2 py-1"
                                    v-for="(category, n_index) in form.categories" v-if="form.categories.length > 0">
                                    {{ category_title(category) }}
                                </li>
                                <li v-else class="w-full py-2 italic">
                                    <span class="far fa-circle-info"></span>
                                    No Category Selected
                                </li>
                            </ul>
                        </div>
                        <div class="col-span-2">
                            <category :categories="form.categories" :categoryopen="categoryopen"
                                @UpdateCategoryPopup="update_category_popup" @UpdateCategory="update_category">
                            </category>
                        </div>
                        <div v-if="form.errors.categories" class="form-error">Category required.</div>
                    </div>

                    <div class="sm:col-span-3 grid grid-cols-2 gap-y-2 gap-x-1 mb-1">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-400">Keyword</label>
                        <Button :name="'Add'" :icon="'far fa-plus-circle'" :method="open_keyword_popup"></Button>
                        <div class="col-span-2 grid grid-cols-2 gap-y-2 gap-x-1 mb-1 border-t border-gray-300 p-3">
                            <ul class="flex  flex-wrap gap-2 col-span-2">
                                <li class="flex items-center w-auto c-list px-2 py-1"
                                    v-for="(keyword, n_index) in form.keywords" v-if="form.keywords.length > 0">
                                    {{ keyword_title(keyword) }}
                                </li>
                                <li v-else class="w-full py-2 italic">
                                    <span class="far fa-circle-info"></span>
                                    No keyword Selected
                                </li>
                            </ul>
                        </div>
                        <div class="col-span-2">
                            <keyword :keywords="form.keywords" :keywordopen="keywordopen"
                                @UpdateKeywordPopup="update_keyword_popup" @UpdateKeyword="update_keyword">
                            </keyword>
                        </div>
                    </div>

                    <div class="sm:col-span-3 grid grid-cols-2 gap-y-2 gap-x-1 mb-1">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-400">Property Type</label>
                        <Button :name="'Add'" :icon="'far fa-plus-circle'" :method="open_property_type_popup"></Button>
                        <div class="col-span-2 grid grid-cols-2 gap-y-2 gap-x-1 mb-1 border-t border-gray-300 p-3">
                            <ul class="flex  flex-wrap gap-2 col-span-2">
                                <li class="flex items-center w-auto c-list px-2 py-1"
                                    v-for="(property_type, n_index) in form.property_types"
                                    v-if="form.property_types.length > 0">
                                    {{ property_type_title(property_type) }}
                                </li>
                                <li v-else class="w-full py-2 italic">
                                    <span class="far fa-circle-info"></span>
                                    No property type Selected
                                </li>
                            </ul>
                        </div>
                        <div class="col-span-2">
                            <property-type :property_types="form.property_types" :property_typeopen="property_typeopen"
                                @UpdatePropertyTypePopup="update_property_type_popup"
                                @UpdatePropertyType="update_property_type">
                            </property-type>
                        </div>
                    </div>

                    <div class="sm:col-span-3 grid grid-cols-2 gap-y-2 gap-x-1 mb-1">
                        <label class="block text-sm font-medium text-gray-700 dark:text-gray-400">Attachment</label>
                        <Button :name="'Add'" :icon="'far fa-plus-circle'" :method="open_attachment_popup"></Button>
                        <div class="col-span-2 grid grid-cols-2 gap-y-2 gap-x-1 mb-1 border-t border-gray-300 p-3">
                            <ul class="flex  flex-wrap gap-2 col-span-2">
                                <li class="flex items-center w-auto c-list px-2 py-1"
                                    v-for="(attachment, n_index) in form.attachments"
                                    v-if="form.attachments.length > 0">
                                    {{ attachment_title(attachment) }}
                                </li>
                                <li v-else class="w-full py-2 italic">
                                    <span class="far fa-circle-info"></span>
                                    No Attachment Selected
                                </li>
                            </ul>
                        </div>
                        <div class="col-span-2">
                            <attachment :attachments="form.attachments" :attachmentopen="attachmentopen"
                                @UpdateAttachmentPopup="update_attachment_popup" @UpdateAttachment="update_attachment">
                            </attachment>
                        </div>
                    </div>

                    <div class="sm:col-span-3 grid grid-cols-2 gap-y-2 gap-x-1 mb-1">
                        <div class="flex items-center col-span-2">
                            <label class="block text-sm font-medium text-gray-700 dark:text-gray-400">Rooms</label>
                            <Button :name="'Add'" :icon="'far fa-plus-circle'" :method="open_room_popup"></Button>
                        </div>
                        <div class="col-span-2 grid grid-cols-2 gap-y-2 gap-x-1 mb-1 border-t border-gray-300 p-3">
                            <ul class="grid  gap-3 col-span-2">
                                <li class="w-auto rounded-md border- border-gray-300"
                                    v-for="(room, n_index) in form.rooms" v-if="form.rooms.length > 0">
                                    <div class="flex align-middle item_block  border-b-2 border-gray-200">
                                        <div class="p-2 inline-block align-middle">
                                            <img :src="room.image_path" alt="profile" class="w-12 h-10 rounded-full"
                                                v-if="room.image_path != null">
                                            <span v-else class="align-middle fa-duotone fa-image font-30 p-2"></span>
                                        </div>
                                        <div class="w-full relative p-2">
                                            <i class="fa-duotone fa-trash right-0 text-red-700 top-1 absulate "
                                                @click="removeRooms(n_index, room.id)"></i>
                                            <p>{{ room_type_title(room.room_id) }}</p>
                                            <p>{{ room.room_title }}</p>
                                        </div>
                                    </div>
                                    <button @click="open_accessories_popup(room, n_index)"
                                        class="flex items-center gap-1 ml-auto text-[11px] font-semibold p-2"
                                        type="button" data-v-273d79e2=""><span class="far fa-plus-circle"></span>
                                        Add</button>
                                    <!-- <span @click="open_accessories_popup(room,n_index)">Add</span> -->
                                    <div class="grid grid-cols-4">
                                        <div class="flex align-middle item_block"
                                            v-for="(accessory, m_index) in room.accessories"
                                            v-if="room.accessories.length > 0">
                                            <div class="p-1 inline-block align-middle">
                                                <img :src="accessory.image" alt="profile" class="w-12 h-10 rounded-full"
                                                    v-if="accessory.image != null">
                                                <span v-else-if="accessory.icon != null"
                                                    :class="accessory.icon + 'align-middle font-15 p-1'"></span>
                                                <span v-else
                                                    class="align-middle fa-duotone fa-image font-15 p-2"></span>
                                            </div>
                                            <div class="w-full relative p-1 flex items-center">
                                                <i class="fa-duotone fa-trash right-0 text-red-700 top-1 absulate "
                                                    @click="removeAccessories(n_index, m_index)"></i>
                                                <p>{{ accessories_title(accessory.bed_id) }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li v-else class="w-full py-2 italic">
                                    <span class="far fa-circle-info"></span>
                                    No Room Selected
                                </li>
                            </ul>
                        </div>
                        <div class="col-span-2">
                            <room :rooms="form.rooms" :roomopen="roomopen" @UpdateRoomPopup="update_room_popup"
                                @UpdateRoom="update_room">
                            </room>
                        </div>
                    </div>

                    <div class="sm:col-span-3 grid grid-cols-2 gap-y-2 gap-x-1 mb-1">
                        <div class="flex items-center col-span-2">
                            <label class="block text-sm font-medium text-gray-700 dark:text-gray-400">Meta</label>
                            <Button :name="'Add'" :icon="'far fa-plus-circle'" :method="open_meta_popup"></Button>
                        </div>
                        <div class="col-span-2 grid grid-cols-2 gap-y-2 gap-x-1 my-1">
                            <ul class="grid grid-cols-2 gap-3 col-span-2">
                                <li class="w-auto rounded-md border border-gray-300"
                                    v-for="(meta, n_index) in form.meta_infos" v-if="form.meta_infos.length > 0">
                                    <div class="flex align-middle item_block">
                                        <div class="p-2 inline-block align-middle">
                                            <img :src="meta.image" alt="profile" class="w-12 h-10 rounded-full"
                                                v-if="meta.image != null">
                                            <span v-else class="align-middle fa-duotone fa-image font-30 p-2"></span>
                                        </div>
                                        <div class="w-full relative p-2">
                                            <i class="fa-duotone fa-trash right-0 text-red-700 top-1 absulate "
                                                @click="removeMeta(n_index, meta.id)"></i>

                                            <p>{{ meta.title }}</p>
                                            <p>{{ meta.description }}</p>
                                        </div>
                                    </div>
                                </li>
                                <li v-else class="w-full border-t border-gray-300  p-4 col-span-2 italic">
                                    <span class="far fa-circle-info"></span>
                                    No Meta Selected
                                </li>
                            </ul>
                        </div>
                        <div class="col-span-2">
                            <meta-info :meta_infos="form.meta_infos" :metaopen="metaopen"
                                @UpdateMetaPopup="update_meta_popup" @UpdateMeta="update_meta">
                            </meta-info>
                        </div>
                    </div>
                    <div class="sm:col-span-3 grid grid-cols-2 gap-y-2 gap-x-1 mb-1">
                        <div class="flex items-center col-span-2">
                            <label class="block text-sm font-medium text-gray-700 dark:text-gray-400">Gallery <span
                                    class="custom-error">*</span></label>
                            <Button :name="'Add'" :icon="'far fa-plus-circle'" :method="open_gallery_popup"></Button>
                        </div>
                        <div class="col-span-2 gap-y-2 gap-x-1 my-1">
                            <gallery-view :galleries="form.galleries" @UpdateGalleryList="update_gallery_list" />
                        </div>
                        <div class="col-span-2">
                            <gallery :galleries="form.galleries" :galleryopen="galleryopen"
                                @UpdateGalleryPopup="update_gallery_popup" @UpdateGallery="update_gallery">
                            </gallery>
                        </div>
                        <div v-if="form.errors.galleries" class="form-error">Gallery required.</div>
                    </div>
                    <div class="sm:col-span-3 grid grid-cols-2 gap-y-2 gap-x-1 mb-1">
                        <div class="flex items-center col-span-2">
                            <label class="block text-sm font-medium text-gray-700 dark:text-gray-400">Property Stay
                                Activity
                                Type <span class="custom-error">*</span></label>
                            <Button :name="'Add'" :icon="'far fa-plus-circle'"
                                :method="open_activity_type_popup"></Button>
                        </div>
                        <div class="col-span-2 grid grid-cols-2 gap-y-2 gap-x-1 my-1">
                            <ul class="grid grid-cols-2 gap-3 col-span-2">
                                <li class="w-auto rounded-md border border-gray-300"
                                    v-for="(activity_type, n_index) in form.activity_types"
                                    v-if="form.activity_types.length > 0">
                                    <div style='background-color:rgb(255, 255, 255)' class="item_block">
                                        <div class="bg-white rounded p-4 shadow md:flex justify-between relative"
                                            style="cursor: auto;">
                                            <i class="fa-light fa-xmark right-0 text-red-700 top-1 absulate del"
                                                @click="removeType(n_index, activity_type.id)"></i>
                                            <i class="fa-light fa-edit right-6 text-blue-700 top-1 absulate edit-icon"
                                                @click="editType(n_index)"></i>
                                            <div>
                                                <h4 class="text-[18px] font-semibold">{{ activity_type.name
                                                }}-{{ activity_type_title(activity_type.activity_type_id) }}</h4>
                                                <p
                                                    v-if="activity_type.is_invoiceable == true && activity_type.price != null">
                                                    <span class="fa-duotone fa-money-bill"></span> {{
                                                        activity_type.price }}
                                                </p>
                                                <p v-else-if="activity_type.is_invoiceable == false">
                                                    <span class="fa-duotone fa-tag"></span> Free
                                                </p>
                                                <p v-if="activity_type.discount != null && activity_type.discount > 0">
                                                    <span class="fa-duotone fa-money-bill"></span> Discount: {{
                                                        activity_type.discount }}
                                                </p>
                                                <div class="flex items-center mt-4">
                                                    <div
                                                        class="text-xs uppercase font-bold tracking-wider bg-gray-300 inline-block px-2 py-1 rounded mr-2">
                                                        <span class="fa-duotone fa-hourglass-start"></span>
                                                        {{ activity_type.checkin_time }}
                                                    </div>
                                                    <div
                                                        class="text-xs uppercase font-bold tracking-wider bg-gray-300 inline-block px-2 py-1 rounded mr-2">
                                                        <span class="fa-duotone fa-hourglass-end"></span>
                                                        {{ activity_type.checkout_time }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="text-right md:ml-8 flex items-center">
                                                <div class="flex md:block -mx-2 md:mx-0 mt-3 md:mt-0">
                                                    <div class="flex justify-end mb-1 px-2 md:px-0"
                                                        v-if="activity_type.activity_type_id == 1">
                                                        <div class="text-xl">{{ activity_type.number_of_day }}</div>
                                                        <div class="ml-2">
                                                            <span class="fa-duotone fa-house-day text-[19px]"></span>
                                                        </div>
                                                    </div>
                                                    <div class="flex justify-end items-bottom mb-1 px-2 md:px-0"
                                                        v-if="activity_type.activity_type_id == 2">
                                                        <div class="text-xl">{{ activity_type.number_of_night }}</div>
                                                        <div class="ml-2">
                                                            <span class="fa-duotone fa-house-night text-[19px]"></span>
                                                        </div>
                                                    </div>
                                                    <div class="flex justify-end px-2 md:px-0 "
                                                        v-if="activity_type.activity_type_id == 3">
                                                        <div class="text-xl">{{ activity_type.total_days }}</div>
                                                        <div class="ml-4 text-xl">
                                                            <span
                                                                class="fa-duotone fa-calendar-days  text-[19px]"></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li v-else class="w-full border-t border-gray-300  p-4 col-span-2 italic">
                                    <span class="far fa-circle-info"></span>
                                    No
                                    Property Stay Activity Type Selected
                                </li>
                            </ul>
                        </div>
                        <div class="col-span-2" v-if="activitytypeopen">
                            <activity-type :activity_types="form.activity_types" :activitytypeopen="activitytypeopen"
                                :key="activitytypeopen" :editItem="edit_activity_type"
                                @UpdateActivityPopup="update_activity_popup" @UpdateActivity="update_activity_type">
                            </activity-type>
                        </div>
                        <div v-if="form.errors.activity_types" class="form-error">Property Stay Activity Type required.
                        </div>
                    </div>
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <Button v-if="permission.edit > 0" :type="type" :name="head" :url="createUrl"
                        :loading="form.processing"></Button>
                </div>
            </form>
            <Accessories :accessories="sel_room_accessories" :accessoriesopen="accessoriesopen"
                @UpdateAccessoriesPopup="update_accessories_popup" @UpdateAccessories="update_accessories"
                :acc_index="sel_room_index">
            </Accessories>
        </div>
    </div>
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import { ref, toRefs, inject, onMounted, watch } from 'vue'
import axios from 'axios';
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import SelectInputFunction from '@/Shared/SelectInputFunction'
import LoadingButton from '@/Shared/LoadingButton'
import Breadcrumbs from '@/Shared/Breadcrumbs'
import StatusToogleButton from '@/Shared/StatusToogleButton'
import Button from '@/Shared/Button'
import amenity from './components/Amenity'
import attachment from './components/Attachment'
import category from './components/Categoty'
import keyword from './components/Keyword'
import PropertyType from './components/PropertyType'
import Room from './components/Room'
import Accessories from './components/Accessories'
import MetaInfo from './components/Meta'
import ActivityType from './components/ActivityType'
import PhotoBlock from './Photo';
import Gallery from './components/Gallery';
import ToolTip from '@/Shared/ToolTip'
import GalleryView from './components/GalleryView';

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        Breadcrumbs,
        StatusToogleButton,
        Button,
        TextareaInput,
        PhotoBlock,
        amenity,
        category,
        keyword,
        PropertyType,
        Room,
        MetaInfo,
        Gallery,
        Accessories,
        attachment,
        ActivityType,
        ToolTip,
        GalleryView,
        SelectInputFunction
    },
    layout: Layout,
    props: {
        regions: Array,
        hosts: Array,
        residents: Array,
        post: Object,
        ministries: Array,
        offices: Array,
        office_layers: Array,
        activity_types: Array,
        permission: Array,
        host_id: Number,
        user_role: Number,
    },
    remember: 'form',
    setup(props) {
        const backendPrefix = ref(process.env.MIX_ADMIN_PREFIX)
        const { post, permission, regions, hosts, ministries, office_layers, activity_types, host_id, residents, user_role } = toRefs(props)
        const type = ref('edit')
        const title = ref(post.value.post_title)
        const head = ref('Posts')
        const url = ref('/backend/posts')
        const createUrl = ref('')
        const amenityopen = ref(false)
        const attachmentopen = ref(false)
        const categoryopen = ref(false)
        const keywordopen = ref(false)
        const property_typeopen = ref(false)
        const roomopen = ref(false)
        const metaopen = ref(false)
        const galleryopen = ref(false)
        const accessoriesopen = ref(false)
        const activitytypeopen = ref(false)
        const edit_activity_type = ref(null)
        const sel_room_accessories = ref([])
        const sel_room_index = ref('')
        const cantime = ref('')
        const offices = ref([])
        const office_selected = ref(false)
        const host_selected = ref(false)
        const swal = inject('$swal')
        const elm = ref(this)
        const form = useForm({
            post_title: post.value.post_title,
            slug: post.value.slug,
            post_desc: post.value.post_desc,
            status: post.value.status,
            price_per_night: post.value.price_per_night,
            discount_price_per_night: post.value.discount_price_per_night,
            maximum_guest: post.value.maximum_guest,
            maximum_infants: post.value.maximum_infants,
            maximum_children: post.value.maximum_children,
            maximum_pet: post.value.maximum_pet,
            free_cancelation: post.value.free_cancelation,
            cancelation_time: post.value.cancelation_time,
            longitude: post.value.longitude,
            latitude: post.value.latitude,
            google_address: post.value.google_address,
            host_id: post.value.host_id,
            resident_id: post.value.resident_id,
            region_id: post.value.region_id,
            province_id: post.value.province_id,
            municipality_id: post.value.municipality_id,
            barangay_id: post.value.barangay_id,
            max_boking_day: post.value.max_boking_day,
            min_boking_day: post.value.min_boking_day,
            start_date: post.value.start_date,
            end_date: post.value.end_date,
            map_embedded: post.value.map_embedded,
            restricted: post.value.restricted,
            office_layer_id: post.value.office_layer_id,
            office_id: post.value.office_id,
            ministry_id: post.value.ministry_id,
            note: post.value.note,
            email: post.value.email,
            mobile: post.value.mobile,
            amenities: post.value.amenities ? post.value.amenities : [],
            attachments: post.value.attachments ? post.value.attachments : [],
            categories: post.value.categories ? post.value.categories : [],
            keywords: post.value.keywords ? post.value.keywords : [],
            property_types: post.value.property_types ? post.value.property_types : [],
            rooms: post.value.rooms ? post.value.rooms : [],
            meta_infos: post.value.meta_infos ? post.value.meta_infos : [],
            galleries: post.value.galleries ? post.value.galleries : [],
            activity_types: post.value.activity_types ? post.value.activity_types : [],
        })
        const residentList = ref(residents.value)
        const update = () => {
            swal({
                title: 'Are you sure?',
                text: "You want to proceed with this action",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
            }).then((result) => {
                if (result.isConfirmed) {
                    form.put(`${url.value}/${post.value.id}`)
                    title.value = post.value.post_title
                    swal.fire(
                        'Updated!',
                        'Your infomation has been Updated.',
                        'success'
                    )
                }
            });
        }
        const destroy = () => {
            swal({
                title: 'Are you sure?',
                text: "Do you really want to delete this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    form.delete(`${url.value}/${post.value.id}`)
                    swal.fire(
                        'Deleted!',
                        'Your infomation has been deleted.',
                        'success'
                    )
                }
            });
        }
        const restore = () => {
            swal({
                title: 'Are you sure?',
                text: "You want to restore this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Resore it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    form.put(`${url.value}/${post.value.id}/restore`)
                    swal.fire(
                        'Restored!',
                        'Your infomation has been Restored.',
                        'success'
                    )
                }
            });
        }

        const update_aminety_popup = (val) => {
            amenityopen.value = val
        }

        const update_aminety = (val) => {
            form.amenities = val
        }

        const update_attachment_popup = (val) => {
            attachmentopen.value = val
        }
        const update_attachment = (val) => {
            form.attachments = val
        }

        const update_category_popup = (val) => {
            categoryopen.value = val
        }
        const update_category = (val) => {
            form.categories = val
        }

        const update_keyword_popup = (val) => {
            keywordopen.value = val
        }
        const update_keyword = (val) => {
            form.keywords = val
        }

        const update_property_type_popup = (val) => {
            property_typeopen.value = val
        }
        const update_property_type = (val) => {
            form.property_types = val
        }

        const update_room_popup = (val) => {
            roomopen.value = val
        }

        const update_room = (val) => {
            form.rooms = val
        }

        const update_accessories_popup = (val) => {
            accessoriesopen.value = val
        }

        const update_accessories = (val) => {
            form.rooms[sel_room_index.value].accessories.push(val)
        }

        const update_meta_popup = (val) => {
            metaopen.value = val
        }
        const update_meta = (val) => {
            form.meta_infos = val
        }

        const update_activity_popup = (val) => {

            activitytypeopen.value = val
        }
        const update_activity_type = (val) => {
            if (edit_activity_type.value) {
                // Update existing
                form.activity_types[edit_activity_type.value.index] = val
            } else {
                // Add new
                let obj = form.activity_types.find(o => o.activity_type_id === val.activity_type_id);
                if (obj === undefined) {
                    form.activity_types.push(val)
                } else {
                    alert('You have already add that type');
                }
            }
            edit_activity_type.value = null
        }

        const update_gallery_popup = (val) => {
            galleryopen.value = val
        }
        const update_gallery = (val) => {
            form.gallery = val
        }
        const update_gallery_list = (val) => {
            form.gallery = val
        }

        const amenities_list = ref([])
        const load_amenities = async () => {
            await axios.post(`/${backendPrefix.value}/amenities/activeamenities`)
                .then(function (response) {
                    amenities_list.value = response.data
                }.bind(this));
        }

        const attachments_list = ref([])
        const load_attachments = async () => {
            await axios.post(`/${backendPrefix.value}/serviceinfos/get/attachments`)
                .then(function (response) {
                    //  //console.log(response);
                    attachments_list.value = response.data
                }.bind(this));
        }

        const category_list = ref([])
        const load_category = async () => {
            await axios.post(`/${backendPrefix.value}/categories/activecategories`)
                .then(function (response) {
                    category_list.value = response.data
                }.bind(this));
        }

        const keyword_list = ref([])
        const load_keyword = async () => {
            await axios.post(`/${backendPrefix.value}/keywords/activekeywords`)
                .then(function (response) {
                    keyword_list.value = response.data
                }.bind(this));
        }

        const property_type_list = ref([])
        const load_property_type = async () => {
            await axios.post(`/${backendPrefix.value}/property-types/activepropertytypes`)
                .then(function (response) {
                    property_type_list.value = response.data
                }.bind(this));
        }

        const room_list = ref([])
        const load_rooms = async () => {
            await axios.post(`/${backendPrefix.value}/room-infos/activerooms`)
                .then(function (response) {
                    room_list.value = response.data
                }.bind(this));
        }

        const accessories_list = ref([])
        const load_accessories = async () => {
            await axios.post(`/${backendPrefix.value}/room-accessories/activeaccessories`)
                .then(function (response) {
                    accessories_list.value = response.data
                }.bind(this));
        }

        const type_list = ref([])
        const load_type = async () => {
            await axios.post(`/${backendPrefix.value}/stay-activity-types/activity-type`)
                .then(function (response) {
                    type_list.value = response.data
                }.bind(this));
        }

        const activity_type_title = (value) => {
            const index = type_list.value.findIndex(p => p.id == value);
            return type_list.value[index] ? type_list.value[index].title : null;
        }

        const open_aminety_popup = () => {
            amenityopen.value = true
        }
        const open_attachment_popup = () => {
            attachmentopen.value = true
        }

        const open_category_popup = () => {
            categoryopen.value = true
        }

        const open_keyword_popup = () => {
            keywordopen.value = true
        }

        const open_property_type_popup = () => {
            property_typeopen.value = true
        }

        const open_room_popup = () => {
            roomopen.value = true
        }
        const open_accessories_popup = (data, index) => {
            sel_room_accessories.value = data.accessories
            sel_room_index.value = index
            accessoriesopen.value = true
        }

        const open_meta_popup = () => {
            metaopen.value = true
        }

        const open_activity_type_popup = () => {
            edit_activity_type.value = null
            activitytypeopen.value = true
        }

        const editType = (index) => {
            edit_activity_type.value = { ...form.activity_types[index], index: index }
            console.log("Edit: ", edit_activity_type.value);
            activitytypeopen.value = true
        }

        const open_gallery_popup = () => {
            galleryopen.value = true
        }


        const aminety_title = (value) => {
            const index = amenities_list.value.findIndex(p => p.id == value);
            return amenities_list.value[index] ? amenities_list.value[index].amenity_title : null;

        }

        const attachment_title = (value) => {
            const index = attachments_list.value.findIndex(p => p.id == value);
            return attachments_list.value[index] ? attachments_list.value[index].title : null;

        }

        const keyword_title = (value) => {
            const index = keyword_list.value.findIndex(p => p.id == value);
            return keyword_list.value[index] ? keyword_list.value[index].keyword_title : null;

        }

        const property_type_title = (value) => {
            const index = property_type_list.value.findIndex(p => p.id == value);
            return property_type_list.value[index] ? property_type_list.value[index].type_title : null;

        }

        const category_title = (value) => {
            const index = category_list.value.findIndex(p => p.id == value);
            return category_list.value[index] ? category_list.value[index].category_title : null;
        }

        const room_type_title = (value) => {
            if (value != null) {
                const index = room_list.value.findIndex(p => p.id == value);
                return room_list.value[index] ? room_list.value[index].room_title : null;
            }
        }

        const accessories_title = (value) => {
            if (value != null) {
                const index = accessories_list.value.findIndex(p => p.id == value);
                return accessories_list.value[index] ? accessories_list.value[index].bed_title : null;
            }
        }

        const removeRooms = (index, id = null) => {
            if (index !== -1) {
                if (id != null) {
                    let data = {
                        id: id
                    }
                    axios.post(`/${backendPrefix.value}/posts/destroy-room`, data).then(async (response) => {
                    }).catch(error => {
                    })
                }
                form.rooms.splice(index, 1)
            }
        }
        const removeAccessories = (index, acc_index, id = null) => {
            if (index !== -1 && acc_index !== -1) {
                if (id != null) {
                    let data = {
                        id: id
                    }
                    axios.post(`/${backendPrefix.value}/posts/destroy-accessories`, data).then(async (response) => {
                    }).catch(error => {
                    })
                }
                form.rooms[index].accessories.splice(acc_index, 1)
            }
        }

        const removeMeta = (index, id = null) => {
            if (index !== -1) {
                if (id != null) {
                    let data = {
                        id: id
                    }
                    axios.post(`/${backendPrefix.value}/posts/destroy-meta-info`, data).then(async (response) => {
                    }).catch(error => {
                    })
                }
                form.meta_infos.splice(index, 1)
            }
        }

        const removeActivityType = (index, id = null) => {
            if (index !== -1) {

                if (id != null) {
                    let data = {
                        id: id
                    }
                    axios.post(`/${backendPrefix.value}/posts/destroy-activity-type`, data).then(async (response) => {
                    }).catch(error => {
                    })
                }
                form.activity_types.splice(index, 1)
            }
        }
        const get_office_data = () => {
            let data1 = {
                office_layer_id: form.office_layer_id,
                ministry_id: form.ministry_id,
                geo_region_id: form.region_id,
                geo_province_id: form.province_id,
                geo_municipality_id: form.municipality_id,
                geo_barangay_id: form.barangay_id,
            }
            axios.post(`/${backendPrefix.value}/geomapping/load-offices`, { data: data1 })
                .then(function (response) {
                    offices.value = response.data;
                    office_selected.value = true;
                })
        }

        const removeType = (index, id = null) => {
            if (index !== -1) {
                if (id != null) {
                    let data = {
                        id: id
                    }
                    axios.post(`/${backendPrefix.value}/posts/destroy-activity-type`, data).then(async (response) => {
                    }).catch(error => {
                    })
                }
                form.activity_types.splice(index, 1)
            }
        }
        const setHostData = () => {
            if (user_role.value != 1 && user_role.value != 10) {
                host_selected.value = true
            }
        }
        const slugBuild = () => {
            form.slug = form.post_title.replace(/\s/g, '-').toLowerCase()
        }
        const secondsToDhms = (seconds) => {
            seconds = Number(seconds);
            var d = Math.floor(seconds / (3600 * 24));
            var h = Math.floor(seconds % (3600 * 24) / 3600);
            var m = Math.floor(seconds % 3600 / 60);
            var s = Math.floor(seconds % 60);
            var dDisplay = d > 0 ? d + (d == 1 ? " day " : " days ") : "";
            var hDisplay = h > 0 ? h + (h == 1 ? " hour " : " hours ") : "";
            var mDisplay = m > 0 ? m + (m == 1 ? " minute " : " minutes ") : "";
            var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
            cantime.value = dDisplay + hDisplay + mDisplay + sDisplay;
        }
        const canceltime = () => {
            secondsToDhms(parseInt(form.cancelation_time) * 60);
        }
        watch(() => form.cancelation_time, () => {
            canceltime()
        }, { deep: true })

        watch(() => form.amenities, () => {
            load_amenities()
        }, { deep: true })

        watch(() => form.attachments, () => {
            load_attachments()
        }, { deep: true })

        watch(() => form.categories, () => {
            load_category()
        }, { deep: true })

        watch(() => form.keywords, () => {
            load_keyword()
        }, { deep: true })

        watch(() => form.property_types, () => {
            load_property_type()
        }, { deep: true })

        watch(() => form.rooms, () => {
            load_rooms()
        }, { deep: true })

        watch(() => form.rooms.accessories, () => {
            load_accessories();
        }, { deep: true })

        watch(() => [form.office_layer_id, form.ministry_id, form.region_id, form.province_id, form.municipality_id, form.barangay_id], () => {
            get_office_data();
        }, { deep: true })

        const loadResident = async (e) => {
            if (e.target.value > 0) {
                let data = {
                    host_id: e.target.value
                }
                await axios.post(`/${backendPrefix.value}/tourist/get-resident`, data)
                    .then(function (response) {
                        residentList.value = response.data;
                        console.log(residentList.value);
                    }.bind(this));
            } else {
                residentList.value = [];
            }
        }
        onMounted(() => {
            load_amenities()
            load_attachments()
            load_category()
            load_keyword()
            load_property_type()
            load_rooms()
            load_accessories()
            load_type()
            setHostData()
            cantime
        })

        return {
            form,
            post,
            type,
            title,
            url,
            createUrl,
            update,
            regions,
            head,
            hosts,
            permission,
            amenityopen, open_aminety_popup, update_aminety_popup, update_aminety, amenities_list, load_amenities, aminety_title,
            categoryopen, open_category_popup, update_category_popup, update_category, category_list, load_category, category_title,
            keywordopen, open_keyword_popup, update_keyword_popup, update_keyword, keyword_list, load_keyword, keyword_title,
            property_typeopen, open_property_type_popup, update_property_type_popup, update_property_type, property_type_list, load_property_type, property_type_title,
            roomopen, open_room_popup, update_room_popup, update_room, room_list, load_rooms, room_type_title, removeRooms,
            metaopen, open_meta_popup, update_meta_popup, update_meta, removeMeta,
            galleryopen, open_gallery_popup, update_gallery_popup, update_gallery,
            accessoriesopen, open_accessories_popup, update_accessories_popup, update_accessories, accessories_list, load_accessories, accessories_title, sel_room_index, removeAccessories,
            backendPrefix,
            offices,
            ministries,
            office_layers,
            activity_types,
            get_office_data,
            office_selected,
            attachmentopen, open_attachment_popup, update_attachment_popup, update_attachment, attachments_list, load_attachments, attachment_title,
            activitytypeopen, open_activity_type_popup, editType, update_activity_popup, update_activity_type, removeActivityType, type_list, load_type, activity_type_title, removeType,
            update_gallery_list, host_id, user_role, setHostData, host_selected,
            secondsToDhms,
            canceltime,
            cantime,
            slugBuild,
            residentList,
            loadResident,
            residents,
            edit_activity_type
        }
    }
}
</script>
<style lang="scss" scoped>
$button_height: 36;

.profile_edit_content_block {
    display: block;

    .edit_form_block {
        background-color: #ffffff80;

        textarea,
        select {
            width: 100%;
            border: 1px solid #ddd;
            padding: 5px 10px;
            border-radius: 5px;
        }

        .item_block:hover>div i {
            display: flex !important;
        }

        i {
            width: 30px;
            text-align: center;
            transition: all 0.4s;
            position: absolute;
            margin-right: 0px !important;
            top: 15px;
            font-size: 10px;
            display: none;
            cursor: pointer;

            &.active {
                display: flex !important;
            }

            &.del {
                position: absolute;
                width: 20px;
                height: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #fff;
                border-radius: 50%;
                box-shadow: 0 0 5px #999;
                border: 1px solid #ddd;
                cursor: pointer;
                top: -5px;
                right: -5px;
            }
        }



        .err_msg {
            border-color: #CD0000 !important
        }

        .c-list {
            background: #006699;
            color: #fff;
            padding: 5px 7px;
            border-radius: 15px;
            font-size: 11px;
            max-height: 24px;
        }
    }
}

.save_btn,
.cancel_btn {
    height: #{$button_height}px;
    background-color: #0f8050;
    color: #fff;
    cursor: pointer;
    border-radius: 5px;

    &.cancel_btn {
        border: 1px solid #CD0000;
        color: #CD0000;
        background-color: #fff;
    }
}

.dark {
    .profile_edit_content_block {

        input,
        textarea,
        select {
            background-color: #222;
        }
    }
}

.password_block,
.confirm_password_block {
    p {
        align-items: baseline;
        color: #666;
        display: flex;
        gap: 5px;
        font-size: 10px !important;

        span {
            color: gold !important;
            font-size: 10px !important;
        }
    }

}
</style>
